import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { StatusClient } from "../../parentApi";

const client = new StatusClient(app_uri, axiosClient());

export default client;
